import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/travelcard/`;

const getTravelCards = async () => {
    return await axios.get(API_URL);
};

const addTravelCard = async (data) => {
    return await axios.post(API_URL, data);
};

const deleteTravelCard = async (id) => {
    return await axios.delete(API_URL + id);
};

const updateTravelCard = async (id, data) => {
    return await axios.put(API_URL + id, data);
};

export default {
    getTravelCards,
    addTravelCard,
    deleteTravelCard,
    updateTravelCard
};
